import i18n from "../../../i18n";
import { Notification } from "../../../Utils/Notification";

export const creacteDriverWithfile = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
  };

  // Notification.pushNotif(action.error.response.data.message, 'error');

  return { ...state, addExcelFile: { ...state.addExcelFile, ...updateValue } };
};

export const clearState = (state, action, initialState) => {
  return { ...state, [action.stateName]: initialState[action.stateName] };
};

export const creacteDriverWithfileSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, "success")
  return { ...state, addExcelFile: { ...state, addExcelFile: updateValue } };
};

export const creacteDriverWithfileFail = (state, action) => {
  const updateValue = {
    request: null,
    error: action.error,
  };

  return { ...state, addExcelFile: { ...state.addExcelFile, ...updateValue } };
};

export const deleteDriver = (state, action) => {
  const updateValue = {
    request: action.id,
    response: null,
    error: null,
  };
  return { ...state, DeleteDriver: updateValue };
};

export const deleteDriverSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, "success")
  return { ...state, DeleteDriver: updateValue };
};

export const deleteDriverFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error");
  return { ...state, DeleteDriver: updateValue };
};

export const editDriver = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, editDriver: updateValue };
};

export const editDriverSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, "success")
  return { ...state, editDriver: updateValue };
};

export const editDriverFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, editDriver: updateValue };
};

export const createDriverWithVehicle = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, createDriverWithVehicle: updateValue };
};

export const createDriverWithVehicleSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, createDriverWithVehicle: updateValue };
};

export const createDriverWithVehicleFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error")
  return { ...state, createDriverWithVehicle: updateValue };
};

export const CreateDistributor = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, CreateDistributor: updateValue };
};

export const CreateDistributorSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, "success")
  return { ...state, CreateDistributor: updateValue };
};

export const CreateDistributorFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error")
  return { ...state, CreateDistributor: updateValue };
};

export const getDriver = (state, action) => {
  const updateValue = {
    request: action.driverData,
    error: null,
  };
  return { ...state, getDriver: { ...state.getDriver, ...updateValue } };
};

export const getDriverSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, getDriver: updateValue };
};

export const getDriverFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, getDriver: updateValue };
};

export const getAllDriverOfPlan = (state, action) => {
  const updateValue = {
    request: action.driverData,
    error: null,
  };
  return { ...state, DriverOfPlan: { ...state.DriverOfPlan, ...updateValue } };
};
export const getAllDriverOfPlanSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DriverOfPlan: updateValue };
};
export const getAllDriverOfPlanFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DriverOfPlan: updateValue };
};

export const searchTenantDrivers = (state, action) => {
  const updateValue = {
    request: action.vehicleParam,
    response: null,
    error: null,
  };
  return { ...state, searchTenantDrivers: updateValue };
};

export const searchTenantDriversSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, searchTenantDrivers: updateValue };
};

export const searchTenantDriversFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, searchTenantDrivers: updateValue };
};

export const searchTenantDriverPersonal = (state, action) => {
  const updateValue = {
    request: action.query,
    response: null,
    error: null,
  };
  return { ...state, searchTenantDriverPersonal: updateValue };
};

export const searchTenantDriverPersonalSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, searchTenantDriverPersonal: updateValue };
};

export const searchTenantDriverPersonalFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, searchTenantDriverPersonal: updateValue };
};

export const postDriverInfo = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, postDriverInfo: updateValue };
};

export const postDriverInfoSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, postDriverInfo: updateValue };
};

export const postDriverInfoFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, postDriverInfo: updateValue };
};

export const activeMissionToDriver = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, activeMissionToDriver: updateValue };
};
export const activeMissionToDriverSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, activeMissionToDriver: updateValue };
};
export const activeMissionToDriverFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, activeMissionToDriver: updateValue };
};

export const changeDriverPassword = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DriverPassword: updateValue };
};
export const changeDriverPasswordSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DriverPassword: updateValue };
};
export const changeDriverPasswordFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DriverPassword: updateValue };
};

export const DeleteMissionFromDriver = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DeleteMissionFromDriver: updateValue };
};

export const DeleteMissionFromDriverSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, DeleteMissionFromDriver: updateValue };
};

export const DeleteMissionFromDriverFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, DeleteMissionFromDriver: updateValue };
};
